/* ==========================================================================
   STORMROCK — fiche produit, bloc caractéristiques.

   1. Si les métachamps custom.sr_ligne_1/2/3 sont remplis, le bloc est
      ENTIÈREMENT reconstruit à partir d'eux : trois micro-phrases, le texte
      entre ** passe en gras. Les métachamps d'origine (intensite_du_gout,
      saveur_secondaire, origine) ne sont plus affichés mais restent intacts,
      car origine et saveur servent de facettes de filtre.
   2. Sinon, on garde l'ancien rendu : emoji retiré, libellé et valeur réunis,
      et ligne Saveur de repli depuis window.SR_SAVEUR.
   3. Dans tous les cas, la note « *ajoute un ou deux jours… » est masquée.

   Les valeurs sont exposées par snippets/stylesheets.liquid.
   Mise en forme : assets/sr-carac.css
   ========================================================================== */
(function () {
  'use strict';

  var SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="8.6"/><path d="M8.3 12.2l2.6 2.6 4.8-5.2"/></svg>';

  function echap(t) {
    var d = document.createElement('div');
    d.textContent = t;
    return d.innerHTML;
  }

  /* ** … ** -> <b>…</b>, après échappement : aucune balise ne peut venir
     d'un métachamp. */
  function gras(t) {
    return echap(String(t)).replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
  }

  function rangee(texte) {
    var li = document.createElement('div');
    li.className = 'info';
    li.dataset.srCarac = '1';
    var ic = document.createElement('span');
    ic.className = 'sr-carac-ic';
    ic.innerHTML = SVG;
    var sp = document.createElement('span');
    sp.className = 'sr-carac-t';
    sp.innerHTML = gras(texte);
    li.appendChild(ic);
    li.appendChild(sp);
    return li;
  }

  /* ── 1. reconstruction depuis sr_ligne_1/2/3 ─────────────────────────── */
  function trois() {
    var box = document.querySelector('.caracteristiques');
    if (!box) return false;
    var L = window.SR_CARAC;
    if (!L || !L.length) return false;
    L = [].slice.call(L).filter(function (x) { return x && String(x).trim(); });
    if (!L.length) return false;
    if (box.dataset.srCarac3 === '1') return true;
    box.textContent = '';
    for (var i = 0; i < L.length; i++) box.appendChild(rangee(L[i]));
    box.dataset.srCarac3 = '1';
    return true;
  }

  /* ── 2. ancien rendu, ligne par ligne ──────────────────────────────── */
  function ligne(el) {
    if (el.dataset.srCarac === '1') return;
    var b = el.querySelector('b');
    if (!b) return;
    var libelle = (b.textContent || '').replace(/[:：]\s*$/, '').trim();
    var valeur = '', apres = false, n = el.childNodes;
    for (var i = 0; i < n.length; i++) {
      if (n[i] === b) { apres = true; continue; }
      if (apres) valeur += n[i].textContent || '';
    }
    valeur = valeur.replace(/\s+/g, ' ').trim();
    var ic = document.createElement('span');
    ic.className = 'sr-carac-ic';
    ic.innerHTML = SVG;
    var t = document.createElement('span');
    t.className = 'sr-carac-t';
    var gr = document.createElement('b');
    gr.textContent = libelle;
    t.appendChild(gr);
    t.appendChild(document.createTextNode(valeur ? ' — ' + valeur : ''));
    el.textContent = '';
    el.appendChild(ic);
    el.appendChild(t);
    el.dataset.srCarac = '1';
  }

  function saveur() {
    var box = document.querySelector('.caracteristiques');
    if (!box || box.querySelector('[data-sr-saveur]')) return;
    var v = window.SR_SAVEUR;
    if (!v || !String(v).trim()) return;
    var l = box.querySelectorAll('.info'), origine = null;
    for (var i = 0; i < l.length; i++) {
      var b = l[i].querySelector('b');
      var txt = b ? b.textContent : (l[i].textContent || '');
      if (/saveur/i.test(txt)) return;
      if (/origine/i.test(txt)) origine = l[i];
    }
    var el = document.createElement('div');
    el.className = 'info';
    el.setAttribute('data-sr-saveur', '1');
    var gr = document.createElement('b');
    gr.textContent = 'Saveur :';
    el.appendChild(gr);
    el.appendChild(document.createTextNode(' ' + String(v).trim()));
    if (origine) box.insertBefore(el, origine);
    else box.appendChild(el);
  }

  /* ── 3. note de livraison ──────────────────────────────────────── */
  function note() {
    var p = document.querySelectorAll('.product-details p, .product-information p, main p');
    for (var i = 0; i < p.length; i++) {
      var t = (p[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (t.indexOf('*ajoute un ou deux jours') === 0) {
        var cible = (p[i].closest && p[i].closest('.text-block')) || p[i];
        cible.style.display = 'none';
      }
    }
  }

  function passe() {
    if (!trois()) {
      saveur();
      var l = document.querySelectorAll('.caracteristiques .info');
      for (var i = 0; i < l.length; i++) ligne(l[i]);
    }
    note();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', passe);
  } else {
    passe();
  }
  setTimeout(passe, 800);
  setTimeout(passe, 2000);
})();
